var map = {
	"./bd.yml": "7e03",
	"./bf.yml": "46c7",
	"./cs.yml": "aa95",
	"./da.yml": "0770",
	"./de.yml": "363b",
	"./el.yml": "a6fa",
	"./en.yml": "eb57",
	"./es.yml": "4020",
	"./fc.yml": "1043",
	"./fr.yml": "8755",
	"./it.yml": "2055",
	"./ko.yml": "096c",
	"./nl.yml": "31f5",
	"./ru.yml": "01aa",
	"./sp.yml": "c42c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c36";